export const notificationMessageKeys = {
	timeTriggerAlertDescription: "customer-interactions.time-trigger-alert-description",
	toolsTriggerAlertDescription: "customer-interactions.tools-trigger-alert-description",
	wageringTriggerAlertDescription: "customer-interactions.wagering-trigger-alert-description",
	lossTriggerAlertDescription: "customer-interactions.loss-trigger-alert-description",
	depositTriggerAlertDescription: "customer-interactions.deposit-trigger-alert-description",
	depositLimitReachedAlertDescription: "limits-alert.deposit-limit-reached.message",
	balanceLimitExceededAlertDescription: "limits-alert.balance-limit-exceeded.message",
};
